module.exports = __webpack_public_path__ + "img/four1Orange.596a2c08.jpg";